
import { ConfigRepository } from '../repositories/ConfigRepository';

export class ConfigService {
  private repository: ConfigRepository;

  constructor() {
    this.repository = ConfigRepository.getInstance();
  }

  /**
   * Get all models
   */
  public async getConfig(): Promise<any> {
    return await this.repository.getConfig();
  }

}

// Export singleton instance
export const configService = new ConfigService();
